import { memo } from 'react'
import { Grid as MuiGrid, GridProps } from '@mui/material'

export type { GridProps }

function Grid(props: GridProps) {
  return <MuiGrid {...props} />
}

export default memo(Grid)
